<template>
    <component :is="template">
        <div>
            <div class="tit-wrap tit-wrap--unberline">
                <h2 class="tit">장바구니</h2>
            </div>

            <div class="mb-30px mb-md-40px">
                <v-btn-toggle v-if="filter.isDeduction || !filter.isDeduction" tile class="d-flex">
                    <v-flex xs6 class="v-btn px-0">
                        <v-btn :color="filter.isDeduction ? 'primary': 'white'" active-class="no-active" width="100%" x-large tile elevation="0" :value="true" @click="filter.isDeduction = true"><v-icon class="mr-2 ml-n4" :color="filter.isDeduction ? 'white' : 'grey'">{{ mdiBookOpenPageVariant }}</v-icon>도서상품</v-btn>
                    </v-flex>
                    <v-flex xs6 class="v-btn px-0">
                        <v-btn :color="!filter.isDeduction ? 'primary': 'white'" active-class="no-active" width="100%" x-large tile elevation="0" :value="false" @click="filter.isDeduction = false"><v-icon class="mr-2 ml-n4" :color="filter.isDeduction ? 'grey' : 'white'">{{ mdiReceipt }}</v-icon>일반상품</v-btn>
                    </v-flex>
                </v-btn-toggle>
            </div>
        </div>

        <div>
            <div class="py-10px py-md-16px">
                <v-checkbox :input-value="this.selected.length == carts.length" label="전체선택" hide-details class="ma-0 px-0" @click.stop="selectAll"/>
            </div>

            <template v-for="cart, index in carts">
                <v-divider :key="index"/>
                <cart-item v-model="selected" :key="cart._id" :cart="cart" :carts="carts" @remove="remove" @edit="(b) => { a(b, index) }"/>
            </template>

            <v-divider/>
            <div class="py-10px py-md-16px">
                <v-row align="center" class="row--small font-size-14 text-right">
                    <v-spacer></v-spacer>
                    <v-col cols="auto">
                        총 상품가격
                    </v-col>
                    <v-col cols="3">
                        <div class="d-inline-flex align-center font-size-18 font-size-md-20 line-height-1">
                            <b>{{ saleAmount.format() }}</b><span class="font-size-16 ml-2px">원</span>
                        </div>
                    </v-col>
                </v-row>
                <v-row align="center" class="row--small font-size-14 text-right">
                    <v-spacer></v-spacer>
                    <v-col cols="auto">
                        배송비
                    </v-col>
                    <v-col cols="3">
                        <div class="d-inline-flex align-center font-size-18 font-size-md-20 line-height-1">
                            <b>{{ shippingAmount.format() }}</b><span class="font-size-16 ml-2px">원</span>
                        </div>
                    </v-col>
                </v-row>
            </div>

            <v-divider/>

            <div class="pt-10px pt-md-16px">
                <v-row align="center" class="row--small font-size-14 text-right">
                    <v-spacer></v-spacer>
                    <v-col cols="auto">
                        총 결제 예상 금액
                    </v-col>
                    <v-col cols="3">
                        <div class="d-inline-flex align-center font-size-20 font-size-md-24">
                            <b class="primary--text">{{ totalAmount.format() }}</b><span class="font-size-14 ml-2px">원</span>
                        </div>
                    </v-col>
                </v-row>
            </div>
        </div>

        <div class="mt-20px mt-md-30px">
            <v-row class="row--x-small">
                <v-col cols="auto">
                    <v-btn large outlined color="grey" elevation="0" @click="removeAll"><span class="grey--text text--darken-3">전체삭제</span></v-btn>
                </v-col>
                <v-spacer/>
                <v-col cols="auto">
                    <v-btn large color="primary" elevation="0" @click="pickup">주문하기</v-btn>
                </v-col>
            </v-row>
        </div>
    </component>
</template>
<script>
import api from "@/api";
import { mdiReceipt, mdiBookOpenPageVariant  } from "@mdi/js";
import CartItem from "@/components/client/shop/cart/cart-item.vue";
export default {
    components: {
        CartItem
    },
    data(){
        return {
            mdiReceipt,
            mdiBookOpenPageVariant,

            filter: {
                isDeduction: true // 공제 유형 (true: 문화/도서 소득공제, false: 일반상품)
            },

            carts: [],
            selected: [],
            setting: [],

            page: 1,
            pageCount: 0,
            limit: 10,
        }
    },
    mounted(){
        this.init();
    },
    methods: {
        a(b, index){
            this.carts[index].product = b.product
            this.carts[index].quantity = b.quantity
        },
        async init(){
            await this.search(false);
        },
        async search(routable = false){
            let { carts } = await api.v1.me.shop.carts.gets();

            let { setting } = await api.v1.shop.setting.get();
            this.setting = setting;

            let { products } = await api.v1.shop.products.gets({
                headers: {
                    skip: 0,
                    limit: 0
                },
                params: {
                    type: ["main", "option", "addition", "ebook"],
                    searchKey: "_id",
                    searchValue: carts.map(cart => cart.product._id)
                }
            });

            console.log(carts);
            console.log(products);

            carts.forEach(cart => {
                cart.product = products.find(product => product._id == cart.product._id)
            });
            this.carts = carts.filter(cart => !!cart.product && cart?.product?.isDeduction == this.filter.isDeduction);

            console.log(this.carts);
        },

        async remove(cart){
            if(confirm("장바구니에서 삭제하시겠습니까?")){
                await api.v1.me.shop.carts.delete(cart);
                await this.search();
                this.selected.splice(this.selected.indexOf(cart._id), 1);
            }
        },

        async removeAll(){
            if(confirm("장바구니를 전부 삭제하시겠습니까?")){
                for(let cart of this.carts){
                    await api.v1.me.shop.carts.delete(cart);
                }
                await this.search();
                this.selected = [];
            }
        },

        selectAll(){
            if(this.selected.length == this.carts.length){
                this.selected = [];
            }
            else {
                this.carts.forEach(cart => {
                    if(this.selected.indexOf(cart._id) < 0) this.selected.push(cart._id)
                });
            }
        },

        validate(){
            try{
                if(!this.selected.length) throw new Error("주문하실 상품을 선택해주세요");

                let stockMessage = ""
                let item = this.selected.map(_id => this.carts.find(cart => cart._id == _id)).filter(el => el.product.stock === 0).map(el => {
                    if(el.product._mainProduct){
                        stockMessage = stockMessage + `${el.product.name} [${el.product.optionalNames.toString()}] : ${el.product.optionalValues.toString()}, `
                    } else {
                        stockMessage = stockMessage + `${el.product.name}, `
                    }
                })

                if(stockMessage) throw new Error(`${stockMessage} \n품절된 상품입니다.`)

                return true;
            }
            catch(error){
                alert(error.message);
            }
            return false;
        },

        async pickup(){
            if(this.validate()){
                await this.$store.dispatch("pickup", {
                    carts: this.selected.map(_id => this.carts.find(cart => cart._id == _id))
                });

                this.$router.push(`/shop/order`);
            }
        }
    },
    computed: {
        template(){ return () => import(`@/templates/${this.$theme.pages.mypage}`); },

        accessToken(){
            return this.$store.state.accessToken;
        },

        saleAmount(){
            let saleAmount = this.selected.map(_id => this.carts.find(cart => cart._id == _id)).reduce((saleAmount, cart) => saleAmount + cart.product.salePrice * cart.quantity, 0);

            return saleAmount;
        },

        shippingAmount(){
            // let shippingAmount = this.selected.map(_id => this.carts.find(cart => cart._id == _id)).reduce((shippingAmount, cart) => shippingAmount + cart.product.shippingPrice, 0);

            let pickups = this.selected.map(_id => this.carts.find(cart => cart._id == _id))
            let shippingAmount = 0;
            let setting = this.setting;

            let freeItem = pickups.filter(el => el.product.shippingCode === "free")
            let orderItem = pickups.filter(el => el.product.shippingCode === "order")
            let selfItem = pickups.filter(el => el.product.shippingCode === "self")
            
            if(orderItem.length === pickups.length && orderItem.length){
                if(this.saleAmount >= setting.saleAmount){
                    return shippingAmount
                } else {
                    return setting.shippingPrice.lt
                }
            }

            if(freeItem.length){
                if(this.setting.freePolicyCode === 'free') return shippingAmount
            } else {
                if(this.setting.productPolicyCode === 'product2'){
                    let max = 0
                    for(let i = 0; i < pickups.length; i++){
                        if(pickups[i].product.shippingCode === 'order'){
                            if(max < setting.shippingPrice.lt) max = setting.shippingPrice.lt
                        } else {
                            if(max < pickups[i].product.shippingPrice) max = pickups[i].product.shippingPrice
                        }
                    }
                    return max
                }
            }


            // 상품 배송정책
            shippingAmount += pickups.filter(pickup => pickup.product.shippingCode == "self").reduce((shippingAmount, pickup) => +pickup.product.shippingPrice + shippingAmount, 0);

            // 주문 배송정책
            let saleAmount = pickups.filter(pickup => pickup.product.shippingCode == "order").reduce((saleAmount, pickup) => saleAmount + pickup.product.salePrice * pickup.quantity, 0);
            if(pickups.some(pickup => pickup.product.shippingCode == "order")) shippingAmount += setting.saleAmount <= saleAmount ? setting.shippingPrice.gt : setting.shippingPrice.lt;

            return shippingAmount;
        },

        totalAmount(){
            return this.saleAmount + this.shippingAmount;
        }
    },
    watch: {
        "filter.isDeduction"(){
            this.selected = [];
            this.search();
        }
    }
}
</script>

<style scoped>
.v-btn-toggle>>>.v-btn {
    opacity: 1 !important;
}
</style>